import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { CstClarionService } from "src/app/services/clarion.service";
import { UserService } from "src/app/services/user.service";
import {
  AdministrationClientProvider,
  DevicePlatform,
  LoginCommand,
} from "src/app/web-api/web-api";

@Component({
    templateUrl: "./clarion_login.component.html",
    styleUrls: ["./clarion_login.component.scss"],
    standalone: false
})
export class ClarionLoginComponent implements OnInit {
  private _route = inject(ActivatedRoute);
  private _router = inject(Router);
  private _adminClient = inject(AdministrationClientProvider);
  private _userService = inject(UserService);
  private _clarion = inject(CstClarionService);

  private _skipSettingClarionMode = false;
  public redirectionURL = "";
  public accessToken = "";
  public thouShallNotPass = false;
  public thereMayBeErrors = false;
  public wrongBrowser = false;
  public noLicence = false;
  public logInCompleted = false;
  public TheError = "";

  ngOnInit(): void {
    this.redirectionURL =
      this._route.snapshot.queryParamMap.get("redirectionUrl") || "--";
    this.accessToken =
      this._route.snapshot.queryParamMap.get("accessToken") || "--";
    this._skipSettingClarionMode =
      this._route.snapshot.queryParamMap.get("skipSettingClarionMode") ===
      "true";

    this.thouShallNotPass = false;
    if (this.accessToken !== "--") {
      this.OnSubmit();
    } else {
      this.thereMayBeErrors = true;
    }
  }
  
  OnSubmit() {
    const cmd = new LoginCommand();
    cmd.token = this.accessToken;
    cmd.username = "";
    cmd.password = "";
    cmd.platform = DevicePlatform.Browser;
    this._adminClient.login(cmd).subscribe(
      (result) => {
        let anyLic = false;
        for (const prop of Object.keys(
          result.settings.system.internalServices
        )) {
          if (!prop.toLowerCase().endsWith("islicensed")) {
            continue;
          }
          if (result.settings.system.internalServices[prop] === true) {
            anyLic = true;
            break;
          }
        }
        if (!anyLic) {
          this.noLicence = true;
          return;
        }
        this.thouShallNotPass = false;
        this._userService.Login(result);
        this.logInCompleted = true;
        if (!this._skipSettingClarionMode) {
          this._clarion.connect();
        }
        if (this.redirectionURL !== "--") {
          this._router.navigateByUrl(this.redirectionURL, {
            replaceUrl: true, /// so that this clarion login page is not part of the browser history
          });
          setTimeout(() => {
            this._router.events.subscribe((event) => {
              if (!(event instanceof NavigationStart)) return;
              const navBackUrl = this._router.routerState.snapshot.url;
              const prevUrl = this._getAbsoluteUrl(
                this._router.routerState.snapshot.url
              );
              const requestedUrl = this._getAbsoluteUrl(event.url);
              const requestedUrlHref = requestedUrl.href;
              if (
                `${prevUrl.protocol}${prevUrl.host}${prevUrl.pathname}` ===
                `${requestedUrl.protocol}${requestedUrl.host}${requestedUrl.pathname}`
              ) {
                return;
              }
              window.open(requestedUrlHref, "_blank");
              this._router.navigateByUrl(navBackUrl);
            });
          }, 1000);
        } else {
          this.thereMayBeErrors = true;
          return;
        }
      },
      (error: any) => {
        console.log(error);
        this.thereMayBeErrors = true;
        return;
      }
    );
  }

  private _getAbsoluteUrl(url: string) {
    if (!url) {
      return new URL(document.baseURI);
    }
    if (url.startsWith("/")) {
      return new URL(url, document.baseURI);
    }
    return new URL(url);
  }
}
